import React from "react";

import { Grid } from "@mui/material";

import { Title } from "./styles";

interface Props {
  name?: string;
  children: React.ReactChild;
  style?: React.CSSProperties;
  className?: string;
}

const Section = (props: Props) => {
  const { name, children, style, className } = props;

  return (
    <Grid item container direction="row" spacing={2} style={style} className={className}>
      {name && (
        <Grid item xs={12}>
          <Title>{name}</Title>
        </Grid>
      )}
      {children}
    </Grid>
  );
};

export default Section;
